
import Vue from 'vue'

export default Vue.extend({
  name: 'ExpandableCheckbox',
  props: {
    value: {
      type: Boolean,
    },
    shortLabel: {
      type: String,
    },
    longLabel: {
      type: String,
    },
    expandedLinkTitle: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
    },
  },
  computed: {
    label: function (): string {
      if (this.expanded) {
        return this.longLabel
      }

      return this.shortLabel
    },
  },
  data: () => ({
    expanded: false,
  }),
})
